/**
 * Formats time and ensures that single character minutes or hours will be
 * outputted as "01", "02", "03", etc.
 */
export const formatTime = (time: number) => String(time).padStart(2, '0');

// Takes a date and adds hours and minutes
export const setTimeFor = (date: Date, { hours, minutes }: { hours: number; minutes: number }) => {
  date.setHours(hours);
  date.setMinutes(minutes);
  // Strip the seconds out to remove any unexpected results.
  date.setSeconds(0);
  date.setMilliseconds(0);
};
